module.exports = __webpack_public_path__ + "img/chosen.8c529024.svg";